module.exports = __webpack_public_path__ + "assets/img/37_384_big.2af8c143.jpg";